module.exports = __webpack_public_path__ + "static/media/subscription-big.fe341057.svg";